export default __webpack_public_path__ + "static/Image 44-c3324459ed5e404902191b33a1db319b.png";